export const MAX_PINNED_FAVORITES_DESKTOP = 3
export const MAX_PINNED_FAVORITES_MOBILE = 2

export const FAVORITES_SCROLL = {
  BASE_SPEED_MULTIPLIER: 1.5,
  EXTRA_SPEED_MAX: 4.5,
  EXTRA_SPEED_STEP_AFTER_FIFTH: 0.05,
}

export const FAVORITES_BOUNCE_INTERVAL_MS = 5000
